import * as Yup from 'yup';

// Defaults
export const formValues = {
    name: '',
    activityCode: '',
    yCode: '',
    wasteCodeId: '',
    includedInReport: true,
    primaryLoadingCode: '',
}

export const validation = () => (
    Yup.object({
        name: Yup.string()
            .required('Názov evidenčného listu je povinný.')
            .min(1, 'Minimálny počet znakov je 1.')
            .max(50, 'Maximálny počet znakov je 50.'),
        activityCode: Yup.string()
            .required('Kód činnosti je povinný.'),
        wasteCodeId: Yup.string()
            .required('Kód odpadu je povinný.'),
        primaryLoadingCode: Yup.string()
            .when('activityCode', {
                is: 'R',
                then: (schema) => schema.required('Pre kód činnosti R je povinné vybrať hlavný kód nakladania.'),
                otherwise: (schema) => schema.optional()
            })
    })
)